import React from "react";
import {
    Button,
    Form,
    FormGroup,
    Label,
    Col,
    Container,
    Row
} from "reactstrap";

import SelectList from "../../components/SelectList/selectList";

const SearchPanel = ({
                         contentErrorText,
                         categories,
                         selectedFilterMode,
                         onFilterModeValueChange,
                         onSearch,
                         onSelectedFilterValuesChange,
                         filterValueKey,
                         filterOptions,
                         filterLabelKey,
                         filterValues
                     }) => {
    return (
        <Form onSubmit={e => e.preventDefault()}>
            <Container>
                <Row>
                    <Col xs="6" sm="4">
                        <FormGroup className="mb-4">
                            <Label>Categories</Label>
                            <SelectList
                                data={categories}
                                valueKey="Id"
                                textField="Name"
                                selectValue={selectedFilterMode.Id}
                                onValueChange={onFilterModeValueChange}
                                notClearable
                                defaultValue={categories[0]}
                            />
                        </FormGroup>
                    </Col>
                    <Col xs="6" sm="6">
                        <FormGroup className="mb-4">
                            <Label>Search Box</Label>
                            <SelectList
                                data={filterOptions}
                                multiSelectMode={true}
                                selectValue={filterValues}
                                valueKey={filterLabelKey}
                                textField={filterValueKey}
                                onValueChange={onSelectedFilterValuesChange}
                            />
                            <span style={{ color: "red" }}>{contentErrorText}</span>
                        </FormGroup>
                    </Col>
                    <Col xs="6" sm="1">
                        <label>&nbsp;</label>
                        <Button
                          color={"success"}
                          className="btn-sm btn-rounded px-4 py-2 mr-2 text-white"
                          onClick={() => onSearch(1)}>
                            Search
                        </Button>
                    </Col>
                </Row>
            </Container>
        </Form>
    );
};

export default SearchPanel;
